import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import VozisCasePT from "@/components/vozis/VozisCasePT";
import VozisCaseEN from "@/components/vozis/VozisCaseEN";

const VozisCase = () => {
  const { language } = useLanguage();

  return (
    <>
      <Navigation />
      <main className="pt-20">
        {language === "pt" ? <VozisCasePT /> : <VozisCaseEN />}
      </main>
      <Footer />
    </>
  );
};

export default VozisCase;
